__webpack_require__.p = "https://assets-01.periodica.press/514f4be-19532697771/";